import React, { useContext } from "react";
import { CenterOnPage } from "./CenterOnPage";
import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CircularProgress from "@mui/material/CircularProgress";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import ErrorRounded from "@mui/icons-material/ErrorRounded";
import PlayArrow from "@mui/icons-material/PlayArrow";
import { AccountContext } from "./AccountProvider";
import { useNavigate } from "react-router-dom";
import { Path } from "../Path";
import { usePublishersIWorkFor } from "../publisher/queries";

export const SelectAccountPage = () => {
  const navigate = useNavigate();
  const { setDesignerMode, setPublisherMode, mode, publisherId } = useContext(AccountContext);
  const { data: publishers = [], isLoading } = usePublishersIWorkFor();

  const onDesignerClickHandler = () => {
    setDesignerMode();
    navigate(Path.Home);
  };

  return (
    <CenterOnPage>
      <Card>
        <Box style={{ width: "80vw" }} p={2}>
          <Typography textAlign="center" variant="h4">
            SELECT ACCOUNT
          </Typography>
          <List>
            <ListItemButton onClick={onDesignerClickHandler}>
              <ListItemIcon>{mode === "Designer" && <PlayArrow />}</ListItemIcon>
              <ListItemText primary="My designer account" />
            </ListItemButton>
            {isLoading && <CircularProgress />}
            {!isLoading && !publishers && <ErrorRounded />}
            {!isLoading &&
              publishers &&
              publishers.map((publisher) => {
                const onPublisherClickHandler = () => {
                  setPublisherMode(publisher.id);
                  navigate(Path.Home);
                };

                return (
                  <ListItemButton key={publisher.id} onClick={onPublisherClickHandler}>
                    <ListItemIcon>{mode === "Publisher" && publisher.id === publisherId && <PlayArrow />}</ListItemIcon>
                    <ListItemText primary={publisher.name} />
                  </ListItemButton>
                );
              })}
          </List>
        </Box>
      </Card>
    </CenterOnPage>
  );
};
